<div class="relative">
  <div class="overlayerContent">
    <div class="md:p-5 p-2 relative">
      <div class="bg-primary-500/70 absolute backdrop-blur-md inset-0"></div>
      <img src="/assets/images/patternHover.png"
           alt=""
           class="absolute inset-0  w-full h-full object-fill ">
      <div class="mt-3 flex flex-col items-center justify-center gap-4  md:w-6/12 w-11/12 mx-auto min-h-[340px] intro-x"
           [style]="{'--order':1, 'opacity' : 0}">

        <div class="flex flex-col items-center gap-3 bg-white/30 mix-blend-screen md:p-5 p-3 rounded-md w-full">
          <div class="text-white md:text-xl text-lg ">{{"Tafuta taarifa ya lalamiko lako"|concat|translate}}</div>
          <div class="w-11/12 mx-auto flex items-center bg-[#F8F9F9] p-3 rounded-md">
            <input (input)="onSearchChange($event?.target?.value)"
                   class="w-full outline-none bg-transparent text-black placeholder:text-primary-500"
                   matInput
                   placeholder="{{'Weka namba ya lalamiko lako hapa'|concat|translate}}">
            <mat-icon svgIcon="landingSearch" class="text-gray-400" style="height:20px;width:20px"></mat-icon>
          </div>

          <div class="flex items-center justify-center flex-wrap gap-2">
            <div
              routerLink="/client-feedback/{{searchedKeyword}}"
              class="bg-secondary-500 transition-all rounded-md mx-auto duration-150 ease-linear hover:cursor-pointer hover:rounded-lg
             hover:bg-secondary-400 text-lg  text-primary-500 px-6 py-2 gap-2 flex items-center justify-center">
              <span>{{"Fuatilia mrejesho"|concat|translate}}</span>
            </div>
            <a href="https://emrejeshov2.all.tz/"
               target="_blank"
              class="bg-secondary-500 text-decoration-none transition-all rounded-md mx-auto duration-150 ease-linear hover:cursor-pointer hover:rounded-lg
             hover:bg-secondary-400 text-lg  text-primary-500 px-4 py-2 gap-2 flex items-center justify-center">
              <span>{{"Tuma mrejesho"|concat|translate}}</span>
            </a>

          </div>


        </div>
      </div>
    </div>
    <div class="min-h-[170vh] w-full backdrop-blur-lg" (mouseover)="exitHover.emit(null)"></div>
  </div>
</div>
